/**
 * @file HeaderSection.jsx
 * @author Rishikesh
 * @date 2024-09-11
 * @description Header component of manage-document.
 */
import { Breadcrumbs, Divider, Skeleton, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export const HeaderSection = ({ isLoading }) => {
  return (
    <>
      {isLoading ? (
        <Skeleton variant="rounded" width={180} height={24} />
      ) : (
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/master-settings">Master Settings</Link>
          <Link to="/master-settings/documents">Documents</Link>
          <Typography sx={{ color: "text.primary" }}>
            Manage Document
          </Typography>
        </Breadcrumbs>
      )}
      {isLoading ? (
        <Skeleton sx={{ mt: 3 }} variant="rounded" width={390} height={24} />
      ) : (
        <Typography
          sx={{ mt: 2, mb: 0.5 }}
          fontWeight={700}
          fontSize={24}
          color="#222222"
        >
          Manage Document
        </Typography>
      )}
      {!isLoading && <Divider />}
    </>
  );
};
